import React, { useState, useEffect } from 'react';
import { Svg } from 'src/components/Svg/Svg';
import classnames from 'classnames';
import { Size } from 'src/components/ProductDetail/ProductSizes';

import classes from './ExpandCollapseWrapper.scss';

type Props = {
    itemsAmountCollapsed: number;
    itemsAmountExpanded: number;
    itemHeight: number;
    turnOff?: boolean;
    computedSizes?: Size[];
};

export const ExpandCollapseWrapper: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    itemHeight,
    itemsAmountCollapsed,
    itemsAmountExpanded,
    turnOff,
    computedSizes,
}) => {
    const showCollapseButton = itemsAmountExpanded > 3;
    const deafultCollapsedHeight = showCollapseButton ? itemsAmountCollapsed + 1 : itemsAmountExpanded;
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const [wrapperHeight, setWrapperHeight] = useState<number>(deafultCollapsedHeight * itemHeight + 11);

    const handleWrapperHeight = (expandedOrCollapsed) => {
        setWrapperHeight(
            showCollapseButton
                ? expandedOrCollapsed
                    ? (itemsAmountExpanded + 1) * itemHeight + 11
                    : (itemsAmountCollapsed + 1) * itemHeight + 11
                : (itemsAmountExpanded + 1) * itemHeight - 11,
        );
    };

    const expandCollapseClickHandler = () => {
        handleWrapperHeight(!isExpanded);
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        handleWrapperHeight(isExpanded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [computedSizes]);

    if (turnOff) {
        return <div>{children}</div>;
    }

    return (
        <div className={classes.expandCollapseWrapper} style={{ height: `${wrapperHeight}px` }}>
            {children}
            {showCollapseButton && (
                <div
                    className={classnames(classes.expandCollapseButton, { [classes.expanded]: isExpanded })}
                    style={{ height: `${itemHeight + 10}px` }}
                >
                    <div
                        className={classnames(classes.expandCollapseIcon, { [classes.expanded]: isExpanded })}
                        onClick={expandCollapseClickHandler}
                    >
                        <Svg name="arrow-down" />
                    </div>
                </div>
            )}
        </div>
    );
};
